import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTimeCheckInOnlineStart,
  getTimeCheckInOnlineSuccess,
  getTimeCheckInOnlineFailed,
} from "../redux/timeCheckInOnline";
import { toast } from "react-toastify";

import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getTimeCheckInOnlineAPI } from "core/http/service/timeKeeping";

function* getTimeCheckInOnlineWork(action) {
  const screenCode = action.payload;

  try {
    const res = yield call(getTimeCheckInOnlineAPI, screenCode);
    yield put({
      type: getTimeCheckInOnlineSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getTimeCheckInOnlineFailed.type,
    });
  }
}

function* watchGetTimeCheckInOnline() {
  yield takeLatest(getTimeCheckInOnlineStart.type, getTimeCheckInOnlineWork);
}

export default function* getTimeCheckInOnlineSaga() {
  yield all([watchGetTimeCheckInOnline()]);
}
